/**
 * @generated SignedSource<<c3c9a9467f5ab0d850bfc54a6251a10e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ServicesWithCredits = "AI_STUDIO" | "AI_STUDIO_3D_MODEL_GENERATOR" | "AI_STUDIO_AD_GENERATOR" | "AI_STUDIO_MAGIC_SWAP" | "AI_STUDIO_MULTI_IMAGE_FUSION" | "AI_STUDIO_PRODUCT_STAGING" | "AI_STUDIO_SIDE_GENERATOR" | "AI_STUDIO_UPSCALER" | "AI_STUDIO_VIDEO_GENERATOR" | "AI_STUDIO_VTO" | "GENERATIVE_AI" | "GENERATIVE_AI_DESIGN" | "GENERATIVE_AI_IMAGE_GENERATOR" | "GENERATIVE_AI_PRODUCT_STAGING" | "GENERATIVE_AI_VTO" | "TEST_ORDERS" | "VECTORIZE";
export type useDiscoveryAiCreditsQuery$variables = {
  serviceName: ServicesWithCredits;
};
export type useDiscoveryAiCreditsQuery$data = {
  readonly serviceCredit: {
    readonly credit: number;
    readonly hasSellerPurchasedCredits: boolean;
    readonly trialCreditsUsed: boolean;
    readonly unlimitedCredits: boolean;
  } | null;
};
export type useDiscoveryAiCreditsQuery = {
  response: useDiscoveryAiCreditsQuery$data;
  variables: useDiscoveryAiCreditsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "serviceName"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "serviceName",
    "variableName": "serviceName"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "credit",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unlimitedCredits",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "trialCreditsUsed",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasSellerPurchasedCredits",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDiscoveryAiCreditsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ServiceCredit",
        "kind": "LinkedField",
        "name": "serviceCredit",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDiscoveryAiCreditsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ServiceCredit",
        "kind": "LinkedField",
        "name": "serviceCredit",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e3b894b2593028b65766b68e406a4c41",
    "id": null,
    "metadata": {},
    "name": "useDiscoveryAiCreditsQuery",
    "operationKind": "query",
    "text": "query useDiscoveryAiCreditsQuery(\n  $serviceName: ServicesWithCredits!\n) {\n  serviceCredit(serviceName: $serviceName) {\n    credit\n    unlimitedCredits\n    trialCreditsUsed\n    hasSellerPurchasedCredits\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8f5da6bc5e7f3309525f0cda1ea6b04e";

export default node;
